import { render, staticRenderFns } from "./StudioFooter.vue?vue&type=template&id=577ca848&scoped=true&"
import script from "./StudioFooter.vue?vue&type=script&lang=js&"
export * from "./StudioFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudioFooter.vue?vue&type=style&index=0&id=577ca848&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ca848",
  null
  
)

export default component.exports